let gadgets = {
    'account.notes': () => import('./account/notes'),
    'account.session-tracking': () => import('./account/session-tracking'),
    'acquisio.daily-performance': () => import('./acquisio/daily-performance'),
    'acquisio.daily-performance-geo-fencing': () => import('./acquisio/daily-performance-geo-fencing'),
    'acquisio.exec-summary': () => import('./acquisio/exec-summary'),
    'acquisio.exec-summary-facebook': () => import('./acquisio/exec-summary-facebook'),
    'acquisio.exec-summary-geo-fencing': () => import('./acquisio/exec-summary-geo-fencing'),
    'acquisio.weekly-performance': () => import('./acquisio/weekly-performance'),
    'acquisio.weekly-performance-geo-fencing': () => import('./acquisio/weekly-performance-geo-fencing'),
    'acquisio.welcome': () => import('./acquisio/welcome'),
    'acquisio.top4-ads': () => import('./acquisio/top4-ads'),
    'acquisio.top24-ads-by-clicks': () => import('./acquisio/top24-ads-by-clicks'),
    'authlab.keywords-list': () => import('./authlab/keywords-list'),
    'authlab.keywords-platforms-list': () => import('./authlab/keywords-platforms-list'),
    'authlab.top-ranks-chart': () => import('./authlab/top-ranks-chart'),
    'authlab.top-ranks-platforms-chart': () => import('./authlab/top-ranks-platforms-chart'),
    'calls.lead-details': () => import('./calls/lead-details'),
    'calls.most-active': () => import('./calls/most-active'),
    'calls.new-vs-repeat': () => import('./calls/new-vs-repeat'),
    'calls.summary': () => import('./calls/summary'),
    'calls.summary-budget': () => import('./calls/summary-budget'),
    'calls-forms.daily-activity': () => import('./calls-forms/daily-activity'),
    'calls-forms-ga.campaign-overview': () => import('./calls-forms-ga/campaign-overview'),
    'calls-forms-ga.contacts-overview': () => import('./calls-forms-ga/contacts-overview'),
    'calls-forms-ga.visits-vs-leads-daily': () => import('./calls-forms-ga/visits-vs-leads-daily'),
    'calls-forms-ga.visits-vs-leads-monthly': () => import('./calls-forms-ga/visits-vs-leads-monthly'),
    'calls-forms.most-active': () => import('./calls-forms/most-active'),
    'calls-forms.most-recent': () => import('./calls-forms/most-recent'),
    'calls-forms-search.clicks-vs-leads-daily': () => import('./calls-forms-search/clicks-vs-leads-daily'),
    'calls-forms-search.clicks-vs-leads-daily-nts': () => import('./calls-forms-search/clicks-vs-leads-daily-nts'),
    'calls-forms-search.clicks-vs-leads-monthly': () => import('./calls-forms-search/clicks-vs-leads-monthly'),
    'calls-forms-search.clicks-vs-leads-monthly-nts': () => import('./calls-forms-search/clicks-vs-leads-monthly-nts'),
    'calls-forms-semita.daily-activity': () => import('./calls-forms-semita/daily-activity'),
    'calls-forms-semita.visits-vs-leads-monthly': () => import('./calls-forms-semita/visits-vs-leads-monthly'),
    'facebook.ads-report-list': () => import('./facebook/ads-report-list'),
    'facebook.customer-feedback': () => import('./facebook/customer-feedback'),
    'facebook.customer-feedback-boost': () => import('./facebook/customer-feedback-boost'),
    'facebook.next-posts-ads': () => import('./facebook/next-posts-ads'),
    'facebook.organic-posts': () => import('./facebook/organic-posts'),
    'facebook.page-likes': () => import('./facebook/page-likes'),
    'facebook.posts-ads-snapshot': () => import('./facebook/posts-ads-snapshot'),
    'forms.daily-activity-line': () => import('./forms/daily-activity-line'),
    'forms.lead-details': () => import('./forms/lead-details'),
    'forms.most-active': () => import('./forms/most-active'),
    'forms.most-recent': () => import('./forms/most-recent'),
    'forms-semita.daily-activity-line': () => import('./forms-semita/daily-activity-line'),
    'ga.organic-snapshot': () => import('./ga/organic-snapshot'),
    'ga.search-terms-organic-pie': () => import('./ga/search-terms-organic-pie'),
    'ga.site-snapshot': () => import('./ga/site-snapshot'),
    'gomobi.daily-activity': () => import('./gomobi/daily-activity'),
    'gomobi.geo-locations': () => import('./gomobi/geo-locations'),
    'gomobi.mobile-devices': () => import('./gomobi/mobile-devices'),
    'gomobi.mobile-searches': () => import('./gomobi/mobile-searches'),
    'gomobi.top-apps': () => import('./gomobi/top-apps'),
    'gomobi.traffic-sources': () => import('./gomobi/traffic-sources'),
    'gomobi.upsell': () => import('./gomobi/upsell'),
    'gomobi.visitor-types': () => import('./gomobi/visitor-types'),
    'lbl.activity-log': () => import('./lbl/activity-log'),
    'lbl.business-listings': () => import('./lbl/business-listings'),
    'lbl.business-profile': () => import('./lbl/business-profile'),
    'lbw.g1-welcome': () => import('./lbw/g1-welcome'),
    'lbw.local-vs-national-bar': () => import('./lbw/local-vs-national-bar'),
    'lbw.local-vs-national-pie': () => import('./lbw/local-vs-national-pie'),
    'lbw.tenet-welcome': () => import('./lbw/tenet-welcome'),
    'lbw.visits-by-source': () => import('./lbw/visits-by-source'),
    'lbw.visits-by-source-pie': () => import('./lbw/visits-by-source-pie'),
    'lbw.welcome': () => import('./lbw/welcome'),
    'lms.add-contact': () => import('./lms/add-contact'),
    'lms.contacts-overview': () => import('./lms/contacts-overview'),
    'lms.customer-value': () => import('./lms/customer-value'),
    'lms.dashboard-index': () => import('./lms/dashboard-index'),
    'lms.lead-source-settings': () => import('./lms/lead-source-settings'),
    'lms.leads-by-source': () => import('./lms/leads-by-source'),
    'lms.leads-by-status': () => import('./lms/leads-by-status'),
    'lms.leads-by-user': () => import('./lms/leads-by-user'),
    'lms.user-settings': () => import('./lms/user-settings'),
    'outcomes.overview-outcome': () => import('./outcomes/overview-outcome'),
    'search.ad-creatives': () => import('./search/ad-creatives'),
    'search.ad-creatives-nts': () => import('./search/ad-creatives-nts'),
    'search.ad-extensions': () => import('./search/ad-extensions'),
    'search.ad-scheduling': () => import('./search/ad-scheduling'),
    'semita.browsers-pie': () => import('./semita/browsers-pie'),
    'search.budget-overview': () => import('./search/budget-overview'),
    'search.budget-overview-to': () => import('./search/budget-overview-to'),
    'search.click-details': () => import('./search/click-details'),
    'search.clicks-monthly-chart': () => import('./search/clicks-monthly-chart'),
    'search.click-platform-pie': () => import('./search/click-platform-pie'),
    'search.click-platform-group-pie': () => import('./search/click-platform-group-pie'),
    'search.detailed-ad-creatives': () => import('./search/detailed-ad-creatives'),
    'search.detailed-ad-creatives-ppc': () => import('./search/detailed-ad-creatives-ppc'),
    'search.detailed-ad-creatives-ppc-bing': () => import('./search/detailed-ad-creatives-ppc-bing'),
    'search.gc-overview': () => import('./search/gc-overview'),
    'search.google-ppc-adword-details': () => import('./search/google-ppc-adword-details'),
    'search.keywords-details': () => import('./search/keywords-details'),
    'search.keywords-groups-details': () => import('./search/keywords-groups-details'),
    'search.keywords-top10': () => import('./search/keywords-top10'),
    'semita.daily-activity': () => import('./semita/daily-activity'),
    'semita.entry-exit': () => import('./semita/entry-exit'),
    'search.sc-overview': () => import('./search/sc-overview'),
    'semita.top-referrers': () => import('./semita/top-referrers'),
}

export default {
    install(Vue) {
        Object.keys(gadgets).forEach((name) => {
            Vue.component(name, gadgets[name]);
        });
    }
};